
import {partner} from "@/api/partner";
import {mapActions, mapState} from "vuex";
import {nowDateFn} from "~/utils/globalFunction";
import {getTooltip} from "~/api/privacyPolicy";
import {queryPrivateUrl, queryPrivateUrlList} from "~/utils/queryPrivateUrl";

export default {
  data() {
    return {
      policyInfo:null,//隐私政策弹窗数据
      partnerList: [],
      bannerOptions: {
        loop: true, // 循环模式选项
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {// 自动滑动
          delay: 6000, //6秒切换一次
          disableOnInteraction: false
        },
        slidesPerView: 1,// 可显示的数量
        slidesPerGroup: 1,//移动个数
      },
      swiperList: [
        {
          titleTip:'全国电信和互联网行业职业技能竞赛指定工具软件',
          title1: '固网宽带和移动网络的专业测试工具',
          title2: '丰富的网络测试与诊断功能',
          in: '为网络工程师、装维人员、技术爱好者量身定制综合性网络测试工具，固网',
          in2: '家宽、移动网络均可测试，Android、Windows、iOS、macOS系统均可使用，',
          in3:'支持企业定制化需求改造'
        },
        {
          title1: '让你用较少的投入获得专业、',
          title2: '精准的网络测试能力',
          in: '基于测速网开发的精准稳定测速内核和覆盖全球的服务器网络系统，',
          in2: '推出多种产品、功能SDK和解决方案，满足多个行业的客户需求，解决客户痛点'
        },
        {
          title1: '亿万用户的实测数据',
          title2: '全面、真实反映用户的网络状况',
          in: '基于测速网平台每天百万次的用户实测结果，提供全面、完整、',
          in2: '及时的网络速度、网络质量、网络覆盖、终端设备以及用户体验相关的数据和服务'
        },
        {title1: '实用且有针对性的解决方案', title2: '', in: '基于测速网丰富的基础服务，提供适合于各行业、预集成的产品', in2: '与能力组合，以满足企事业单位网络测试的相关需求'},
        {title1: '个性化量身定制', title2: '为企业创造更多的商业价值', in: '基于测速网自研高性能测速内核和分布式网络测试系统，', in2: '根据客户需求，量身定制各种网络测试产品'},
        {
          title1: '一站式业务咨询服务',
          title2: '深入了解市场行情、用户需求',
          in: '基于测速网多年B&C端用户服务及测速系统开发经验，为企业',
          in2: '洞察用户需求、产品运营策略及转型咨询、技术瓶颈等提供咨询服务'
        },
      ],
      solutionList: [
        {
          title: "网络质量监测系统", url: '/quality-monitoring',
          info: "互联网、物联网设备网络质量监测，后台远程下发拨测任务"
        },
        {
          title: "用户满意度提升", url: '/satisfaction-improvement',
          info: "精准洞察网内用户上网体验，提前解决问题，提升用户满意度",
          redTip:'光华杯获奖方案'
        },
        {
          title: "测速系统私有化部署", url: '/speedtest-deployment',
          info: "基于测速网自研网络速度和网络体验测试系统、客户端工具等产品，为您提供私有化部署定制服务"
        },
        {
          title: "网络设备测速", url: '/network-equipment',
          info: "单/多网卡设备测速服务，可形成分段测速系统"
        },
        {
          title: "大带宽检测", url: '/high-bandwidth',
          info: "千兆、万兆以上带宽检测服务"
        },
        {
          title: "委托测试", url: '/testing-services',
          info: "基于测速网近20年的服务经验，为设备厂商提供专业的委托测试服务"
        },
        {
          title: "添加测速点", url: '/nodes',
          info: "为当地/网内用户提升测速体验"
        },
        {
          title: "内网测速", url: '/intranet',
          info: "精准分析内网中各网络环节、各区域的网速及网络质量情况，定位网络问题，提升用网体验"
        },
      ],
      dataServerList: [
        {info1: '网络速度和', info2: '质量数据'},
        {info1: '网络覆盖', info2: '数据'},
        {info1: '设备的网速和', info2: '信号功率数据'},
        {info1: '用户位置', info2: '数据'},
        {info1: '网络异常', info2: '用户数据'},
        {info1: '更多数据', info2: ''},
      ],
      zixunServerList: [
        {info1: '用户洞察'},
        {info1: '产品运营与转型'},
        {info1: '技术瓶颈突破'},
        {info1: '落地护航'},
      ],
      customList: [
        {info: '网络测速平台'},
        {info: '网络拨测软件'},
        {info: '网络装维软件'},
      ],
      clientList: [
        {info: 'Android'},
        {info: 'iOS'},
        {info: 'Windows'},
        {info: 'macOS'}],
      dataList: [
        {info: '测速节点覆盖'},
        {info: '每年用户'},
        {info: '网络装维软件'},
      ],
      sdkList: [
        {
          title: '网络速度与质量',
          active: true,
          children: [
            {
              title: '网络测速SDK',
              text: '测速网自研测速算法，多系统可用，App、PC应用、路由器等产品均可集成',
              link: '/speedtest-sdk',
              icon:require('@/assets/imgs/solutions/sdk-0-0.svg')
            },
            {
              title: '网络测速插件',
              text: '多用于浏览器测速场景，WEB、移动端H5、小程序内嵌H5均可集成',
              link: '/plugin',
              icon:require('@/assets/imgs/solutions/sdk-0-1.svg')
            },
            {
              title: '命令行测速CLI',
              text: '网络测速命令行，多用于PC设备',
              link: '/cli',
              icon:require('@/assets/imgs/solutions/sdk-0-2.svg')
            },
            {
              title: '实时网速监测SDK',
              text: '设备实时上下行网络速度监测，多用于PC设备',
              link: '/realtime-sdk',
              icon:require('@/assets/imgs/solutions/sdk-0-3.svg')
            },
          ]
        },
        {
          title: '用户感知测试',
          active: false,
          children: [
            {
              title: '网页打开速度SDK',
              text: '主流网站打开速度测试，适用于App、路由器等产品集成使用',
              link: '/web-open-speed-sdk',
              icon:require('@/assets/imgs/solutions/sdk-1-0.svg')
            },
            {
              title: '视频测试SDK',
              text: '视频播放质量测试工具，支持安卓、iOS系统SDK及插件',
              link: '/video-sdk',
              icon:require('@/assets/imgs/solutions/sdk-1-1.svg')
            },
            {
              title: '游戏测速SDK',
              text: '主流游戏平台时延测试，适用于App、路由器等产品集成使用',
              link: '/game-sdk',
              icon:require('@/assets/imgs/solutions/sdk-1-2.svg')
            },
            {
              title: '综合测速SDK',
              text: '资讯、电商、视频等场景主流平台时延测试，适用于App、路由器等产品集成使用',
              link: '/combo-sdk',
              icon:require('@/assets/imgs/solutions/sdk-1-3.svg')
            },
          ]
        },
        {
          title: '场景化网络测试',
          active: false,
          children: [
            {
              title: '全屋Wi-Fi检测SDK',
              text: '全屋Wi-Fi信号强度覆盖、上网体验诊断测试，适用于安卓系统软件产品集成',
              link: '/whole-home-wifi-sdk',
              icon:require('@/assets/imgs/solutions/sdk-2-0.svg')
            },
            {
              title: '异常诊断SDK',
              text: '定位网络问题来源，适用于安卓、iOS系统软件产品集成',
              link: '/appmalf-sdk',
              icon:require('@/assets/imgs/solutions/sdk-2-1.svg')
            },
          ]
        },
        {
          title: '专项测试',
          active: false,
          children: [
            {
              title: 'Wi-Fi分析SDK',
              text: 'Wi-Fi设备参数、干扰、在线终端等状态分析，适用于安卓系统软件产品集成',
              link: '/wifi-analysis-sdk',
              icon:require('@/assets/imgs/solutions/sdk-3-0.svg')
            },
            {
              title: '移动网络检测SDK',
              text: '移动4G、5G等网络，信号强度、邻区等状态分析，适用于安卓系统软件产品集成',
              link: '/mobile-network-sdk',
              icon:require('@/assets/imgs/solutions/sdk-3-1.svg')
            }
          ]
        },
      ],
      showSdkIndex: 0
    }
  },
  computed:{
    ...mapState(['showAboutUpVersion'])
  },
  components:{
    'up-version-alert':()=>import("@/components/upVersionAlert.vue")
  },
  methods: {
    ...mapActions(['setShowAboutUpVersion']),
    /**
     * 获取隐私政策用户协议更新提示
     * */
    getAboutVersion(){
      let nowTime=nowDateFn()
      let oldTime=localStorage.getItem('policyInfoTime')||null
      getTooltip({
        os:'WWW',
        source:'qywz'
      }).then(res=>{
        try {
          let versionAgree=localStorage.getItem('policyInfoVersionAgree')||null
          versionAgree=versionAgree-0
          let versionDisagree=localStorage.getItem('policyInfoVersionDisagree')||null
          versionDisagree=versionDisagree-0
          let version=res.data.version
          // 判断本地同意版本
          if(!versionAgree){
            // 本地同意版本不存在，缓存接口版本
            localStorage.setItem('policyInfoVersionAgree',version)
            localStorage.setItem('policyInfoVersionDisagree',version)
            localStorage.setItem('policyInfoTime',nowTime)
          }else if(versionAgree<version){
            // 本地同意版本存在，并且不等于接口版本
            if(versionDisagree===version&&nowTime!==oldTime||versionDisagree<version){
              //如果本地不同意版本与接口版本一致并且时间不是今天，或者如果本地不同意版本与接口版本不一致
              //进行弹窗
              this.policyInfo=res.data
              this.setShowAboutUpVersion(true)
            }
          }
        }catch (e) {}
      })
    },
    setSdkActive() {
      let index = sessionStorage.getItem('indexSdk');
      if (index) {
        this.clickSdkTitle(index)
      }
    },
    goPage(url) {
      this.$router.push(url)
    },
    async getPartner() {
      try {
        const res = await partner()
        if (res.code === 0) {
          // 使用批量处理工具避免并发过多导致的HTTP2错误
          let list=await queryPrivateUrlList(res.data,'image')
          this.partnerList = list
        }
      } catch (error) {
        console.error('获取合作伙伴失败:', error)
      }
    },
    clickSdkTitle(index) {
      sessionStorage.setItem('indexSdk', index)
      this.sdkList.forEach(item => {
        item.active = false
      })
      this.sdkList[index].active = true
      this.showSdkIndex = index
    },
    goToSdkLink(link) {
      this.$router.push(link)
    }
  },
  mounted() {
    sessionStorage.getItem('loginAlertShow');
    if (sessionStorage.getItem('loginAlertShow')) {
      this.$store.commit('LOGIN_ALERT', true);
      sessionStorage.removeItem('loginAlertShow');
    }
    this.getPartner();
    this.setSdkActive()
    this.getAboutVersion()
  },
}
